import { Product } from "@/redux/feature/videoDashboard/videoDashboardType";
import { ChevronRight, Clock, Video } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const TableMobileView = ({ brand }: { brand: Product }) => {
  return (
    <div className="block md:hidden">
      <div className="bg-white border border-slate-200 hover:border-slate-300 hover:shadow-lg rounded-xl my-3 overflow-hidden transition-all duration-200 group-hover:shadow-xl">
        <div className="p-6">
          {/* Header section */}
          <div className="flex items-start justify-between mb-5">
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-slate-900 text-lg leading-tight mb-2">
                {brand?.productName}
              </h4>
              <p className="text-slate-600 text-sm font-medium">
                {brand?.category}
              </p>
            </div>
            <div className="ml-4 flex-shrink-0">
              <span
                className={`inline-flex px-3 py-1.5 text-xs font-semibold rounded-full border capitalize ${
                  brand?.dataStatus === "ready"
                    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                    : "bg-slate-50 text-slate-600 border-slate-200"
                }`}
              >
                {brand?.dataStatus}
              </span>
            </div>
          </div>

          {/* Stats section */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl p-4 border border-blue-100">
              <div className="flex md:flex-row flex-col items-center gap-2 justify-center">
                <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center mr-3">
                  <Video className="h-5 w-5 text-white" />
                </div>
                <div>
                  <div className="text-lg font-bold text-slate-900 text-center">
                    {brand?.brandVideoCount || 0}
                  </div>
                  <div className="text-xs font-medium text-blue-700 uppercase tracking-wide text-center">
                    Brand Videos
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 rounded-xl p-4 border border-amber-100">
              <div className="flex md:flex-row flex-col justify-center gap-2 items-center">
                <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center mr-3">
                  <Video className="h-5 w-5 text-white" />
                </div>
                <div>
                  <div className="text-lg font-bold text-slate-900 text-center">
                    {brand?.competitorVideoCount || 0}
                  </div>
                  <div className="text-xs font-medium text-amber-700 uppercase tracking-wide text-center">
                    Competitors Videos
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between pt-5 border-t border-slate-100">
            <div className="flex items-center text-slate-500">
              <Clock className="h-4 w-4 mr-2" />
              <span className="text-sm font-medium">
                {brand?.updatedAt} days ago
              </span>
            </div>
            <Link
              to={`/product-collections/${brand.productId}/${brand.brandName}/${brand.productName}/${brand.country}`}
              className="inline-flex items-center px-4 py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold rounded-lg transition-all duration-200 hover:shadow-lg group"
            >
              View Videos
              <ChevronRight className="h-4 w-4 ml-2 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableMobileView;
